import GeneralHelper from "./generalHelper"
import Thumbnail from "./thumbnail"
import View from "./View"
import MessageDictionary from "./MessageDictionary"

export default class Favorites
{
  static hideEmptyFavMessage(hide) {
    this.hideMessageNotFavs = hide;
    if (hide) {
      $(".noFavorites").hide();
      $(".noPatternMessage").hide();
    }
  }
  static add_tuple$(doc_id, tuple)
  {
    if ( Favorites.can_be_added(tuple) )
    {
      return Favorites.load_document_tuples$(doc_id).then(function(r) {
        var e;
        if ( r.length > 0 )
        {
          e = Cx_.filter(r.Items, function(c) {
            var data = JSON.parse(c.Data);
            return ( data.tuple === tuple );
          })[0];
        }
        if ( e === undefined )
        {
          return Cx.Core.Config.create$({ Data: JSON.stringify({ doc: doc_id, tuple : tuple }), Tags:[{ name: '/tuples/'+window.AppInstance.instance().CUSTOMER_HASH }]}).then(function(r) {
            //return Favorites.load_tuples$(true).then(function(r){
              return Cx.resolve(r);
            //});
          });
        }
      });
    }
    else {
      return Cx.reject('Failed to add favorite');
    }
  }

  static remove_tuple$(tuple_id, doc_id)
  {
    return Cx.Core.Config.delete$({ Id: tuple_id });
  }

  // DOC API

  static add_document$(doc_id)
  {
    var tag = {
      Name: '/docs/' + window.AppInstance.instance().CUSTOMER_HASH
      , Type: Cx.Core.Tag.Type.Document
    };

    return Cx.Core.Tag.create$(tag)
    .then(function (t) {
      var tag = {
        Links: [{ Id: doc_id }]
        , Name: '/docs/' + window.AppInstance.instance().CUSTOMER_HASH
        , Type: Cx.Core.Tag.Type.Document
        , Id : t.Id
      };
      return Cx.Core.Tag.link$(tag).then(function(r){
        Favorites.get_favorite_documents$();
        return Cx.resolve(r);
      });
    });
  }

  static remove_document$(doc_id, ext_id)
  {
    var tag = {
      Links: [{ Id: doc_id }]
      , Name: '/docs/' + window.AppInstance.instance().CUSTOMER_HASH
      , Type: Cx.Core.Tag.Type.Document
    };

    return Cx.Core.Tag.create$(tag)
    .then(function (t) {
      var tag = {
        Links: [{ Id: doc_id }]
        , Name: '/docs/' + window.AppInstance.instance().CUSTOMER_HASH
        , Type: Cx.Core.Tag.Type.Document
        , Id : t.Id
      };
      return Cx.Core.Tag.unlink$(tag);
    });
  }

  static delete_documents_container()
  {
    var qs = { "Match":{"Archived":false,"Owned":false,"Shared":true
    , Tags: [{"Name": '/docs/' + window.AppInstance.instance().CUSTOMER_HASH, Owned: true, Shared: true }] }
    ,"Start":0,"SortBy":"Modified","SortDir":"Desc", "IncludeData": true };
    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));
    GeneralHelper.savePatternContainersToLocalStorage('category', hash, null);
  }

  static get_favorite_documents$(reset)
  {
    var qs = { "Match":{"Archived":false,"Owned":false,"Shared":true
    , Tags: [{"Name": '/docs/' + window.AppInstance.instance().CUSTOMER_HASH, Owned: true, Shared: true }] }
    ,"Start":0,"SortBy":"Modified","SortDir":"Desc", "IncludeData": true };
    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));
    var favs = GeneralHelper.getPatternContainersFromLocalStorage('category', hash);
    if(favs && favs.Items && favs.Items.length > 0  && !reset)
    {
      Cx.Core.Document.search$(qs).then(function(r){
        GeneralHelper.savePatternContainersToLocalStorage('category', hash, r);
        return Cx.resolve(r);
      });
      return Cx.resolve(favs);
    }
    else
    {
      return Cx.Core.Document.search$(qs).then(function(r){
        GeneralHelper.savePatternContainersToLocalStorage('category', hash, r);
        return Cx.resolve(r);
      });
    }
  }

    //loading and rendering
    static reset_tuples(reset)
    {
      let qs = { Match: { Tags : [{ Name: '/tuples/' + window.AppInstance.instance().CUSTOMER_HASH }] } } ;
      let hash = GeneralHelper.md5Encode(JSON.stringify(qs));
      GeneralHelper.savePatternContainersToLocalStorage('favorites', []);
    }

  //loading and rendering
  static load_tuples$(reset)
  {
    let qs = { Match: { Tags : [{ Name: '/tuples/' + window.AppInstance.instance().CUSTOMER_HASH }] } } ;
    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));
    var favs = GeneralHelper.getPatternContainersFromLocalStorage('favorites', hash);
    if(favs && favs.Items && favs.Items.length > 0  && !reset)
    {
      Cx.Core.Config.search$(qs).then(function(r){
        GeneralHelper.savePatternContainersToLocalStorage('favorites', hash, r);
      });
      return Cx.resolve(favs);
    }
    else
    {
      return Cx.Core.Config.search$(qs).then(function(r){
        GeneralHelper.savePatternContainersToLocalStorage('favorites', hash, r);
        return Cx.resolve(r);
      });
    }
  }

  static exists$(doc_id, tuple)
  {
    return Favorites.load_tuples$().then(function(r) {
      var e;
      if ( r.Items.length > 0 )
      {
        e = Cx_.filter(r.Items, function(c) {
          var data = JSON.parse(c.Data);
          return ( data.doc === doc_id && data.tuple === tuple );
        })[0];
      }
      return ( e !== undefined );
    });
  }

  static load_document_tuples$(doc_id)
  {
    return Favorites.load_tuples$().then(function(r) {
      return Cx_.filter(r.Items, function(c) {
        return ( JSON.parse(c.Data).doc === doc_id );
      })
    });
  }

  static can_be_added(tuple)
  {
    var add = true ;
    Cx_.forEach(window.AppInstance.instance().favorite_tuples, function(f){
      var fav_tuple =JSON.parse(f.Data).tuple ;
      var data = window.AppInstance.instance().is_raster ? fav_tuple : JSON.parse(fav_tuple);
      var tuple_data = window.AppInstance.instance().is_raster ? tuple : JSON.parse(tuple) ;
      var matching = 0 ;
      if ( data.length === tuple_data.length )
      {
        Cx_.forEach(tuple_data, function(t) {
          var contained = false ;
          if (window.AppInstance.instance().is_raster )
          {
            contained = contained || ( data === tuple ) ;
          }
          else {
            Cx_.forEach(data, function(d) {
              contained  = contained || (d.Item2.Item1 === t.Item2.Item1);
            });
          }
          matching += (contained) ? 1 : 0 ;
        });
        add = add && !( matching === data.length ) ;
      }
    });
    return add ;
  }

  static refresh$(id)
  {
    return Favorites.load_document_tuples$(id).then(function(r) {
      if ( r.length > 0 )
        window.AppInstance.instance().favorite_tuples = r ;
    });
  }

  static reload_tuples$(id, target)
  {
    $('#'+target).html('');
    return Favorites.load_document_tuples$(id).then(function(r) {
      if ( r.length > 0 )
      {
        window.AppInstance.instance().favorite_tuples = r ;
        View.toggle_no_patterns_message();

        Favorites.render_strip(r, target);
        return Cx.resolve();
      }
      else {
        $('#select-favorites-section').hide();
        return Cx.resolve();
      }
    });
  }

  static reload_favorites$(target)
  {
    window.AppInstance.instance().patterns = [];
    $('#pattern-squares').html('');
    View.load_content$('pattern-squares', '/docs/' + window.AppInstance.instance().CUSTOMER_HASH, true).then(function(){
      View.show_step_two();
      $("#BrowserHeading").html('<i class="icon-favorites-heart-solid myfavoriteHeart" ></i>&nbsp;My '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'favorites')+'');

      $(".browser-container").html('<span onclick="window.collection_home();"><span style="cursor:pointer;">Collection Home</span></span> > <span><span>My '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'favorites')+'</span></span>');
      //$(".pattern-name").dotdotdot({ ellipsis: "...",  wrap: "letter"});
    });
  }

  static render_strip(items, target)
  {
    Cx_.forEach(items, function(i) {
      var data = JSON.parse(i.Data);
      var tuple = window.AppInstance.instance().is_raster ? '' : JSON.parse(data.tuple);
      var id = (window.AppInstance.instance().is_raster ? GeneralHelper.sanitize_GID(data.tuple) : window.AppInstance.instance().selected.id );
      Favorites.add_single_item(id.replace("production-", ""), tuple, i.Id).then(function(html){
        $('#'+target).append(html);
        View.resize();
      });
    });
  }
  static add_single_item(id, tuple, config_id)
  {
    var md = ( window.AppInstance.instance().is_raster ) ? window.AppInstance.instance().selected.parent.metadata : window.AppInstance.instance().selected.metadata ;

    return Thumbnail.render_color_thumb_img$(id
    , tuple
    , false
    , md.get('thumbZoom')
    , md.get('thumbWidth')
    , md.get('thumbHeight')
    , md.get('thumbDPI')
    , window.AppInstance.instance().is_raster
    ).then(function(thumb) {
      return Cx.resolve('<div style="position:relative; display: inline-block;"><span class="check-logged-in icon-close-button-heavy delete-favorite removeIcon" data-id="'+config_id+'"/><img class="select-favorite" src="' + thumb + '" width="65px" height="65px" data-id="'+config_id+'" /></div>');
    })
    .catch(function(e) {
      GeneralHelper.errorOut(e);
    });
  }
  static render_event_handler()
  {
    if ( ! window.AppInstance.instance().favorites_events_registered )
    {
      window.AppInstance.instance().favorites_events_registered = true ;
    }
  }

  static AddDocToFavs (swatch) {
    if (swatch == undefined) {
      return;
    }
    Favorites._newSwatch = swatch;
    Favorites.AddDocumentToFavorite();
  }

  static AddToFavoritesClick () {
    $("#add-to-favorites").html('Saving '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' Combination...');
    var tuple = null;
    var doc_id = window.AppInstance.instance().selected.ExternalId;
    if (!window.AppInstance.instance().is_raster)
      tuple = JSON.stringify(ColorHelper.get_swatches_spotcolor_tuples(window.AppInstance.instance().canvas.figures[0]));
    else
      tuple = window.AppInstance.instance().selected.ExternalId;
    Favorites.add_tuple$(window.AppInstance.instance().selected.ExternalParentID, tuple).then(function (fav) {
      $("#add-to-favorites").html('Save your '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination');
      Favorites.refresh$(window.AppInstance.instance().selected.ExternalParentID).then(function () {
        Favorites.add_single_item(window.AppInstance.instance().is_raster ? tuple : window.AppInstance.instance().selected.ExternalParentID, window.AppInstance.instance().is_raster ? '' : JSON.parse(tuple), fav.Id).then(function (item) {
          $('#pattern-favorite-sets').append(item);
          $("#noPatternMessage").hide();
          View.toggle_favorites_button();
          View.resize();
        });
      })
      .catch(function(e) {
        GeneralHelper.errorOut(e);
      });
    }, function (e) {//Error
      open_general_box({
        templateName: "info_modal",
        heading: "ERROR",
        content: "<p>Favorite has already been added</p>",
        buttons: "<a class='orangeButton' onclick='$.colorbox.close();'>OK</a>"
      });
      GeneralHelper.errorOut(e);
      $("#add-to-favorites").html('Save your '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' Combination');
    });
  }

  static AddDocumentToFavorite() {
    let fav = Favorites._newSwatch;
    var is_fav = (/true/i).test(Favorites._newSwatch.dataset['fav']);
    fav.setAttribute('class', '');
    if (is_fav) {
      Favorites.remove_document$(fav.dataset['id'], fav.dataset['external']).then(function () {
        fav.setAttribute('class', 'check-logged-in icon-favorites-heart-outline favIcon');
        fav.dataset['fav'] = false ;
        Favorites.get_favorite_documents$().then(function (favs) {
          window.AppInstance.instance().favorites = favs.Items;
        });
      });
    }
    else {
      Favorites.add_document$(fav.dataset['id']).then(function () {
        fav.setAttribute('class', 'check-logged-in icon-favorites-heart-solid favIcon');
        fav.dataset['fav'] = true ;
        Favorites.get_favorite_documents$().then(function (favs) {
          window.AppInstance.instance().favorites = favs.Items;
        });
      });
    }
    Favorites._newSwatch = null;
  }
}